/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useMemo, useState } from "react";
import { useSharedData } from "bossjob-remote/dist/hooks";
import { selfJobFunctionOptionsKey } from "app/components/providers/configProvider";
import { SingleCascaderSelect } from "app/(new-pages)/components/allSelect/baseSelect/pc/SingleCascaderSelect";
import { isMobile } from "react-device-detect";
import { JobFunctionSingleSelectorFormMobile } from "./mobile";
import classNames from "classnames";
import styles from "./index.module.scss";
import { JobFunctionForPcWithCustom } from "./JobFunctionForPcWithCustom";

export const JobFunctionSingleSelector = (props: {
  value: {
    id: any;
    value: any;
  };
  lang: Record<string, any>;
  onChange: (selectItem?: any) => void;
}) => {
  const { value: outerValue, onChange, lang } = props;
  const config = useSharedData("CONFIG");
  const jobFunctions = (config && config[selfJobFunctionOptionsKey]) ?? [];

  const [value, setValue] = useState([]);
  const profile = lang.profile || {};

  let opts = useMemo(() => {
    return jobFunctions.map((v) => {
      return {
        label: v.value,
        value: v.id,
        children: v.sub_function_list.map((v) => {
          return {
            label: v.value,
            value: v.id,
            children: v.job_titles.map((v) => {
              return {
                ...v,
                label: v.value,
                value: v.id
              };
            })
          };
        })
      };
    });
  }, [jobFunctions]);

  useEffect(() => {
    let result = {};
    let result1 = {};
    let result2 = {};

    opts.forEach((v) => {
      result[v.value] = v;
      if (v.children) {
        (v.children || []).forEach((v1) => {
          result1[v1.value] = v1;
          v1.p = v;
          (v1.children || []).forEach((v2) => {
            result2[v2.value] = v2;
            v2.p = v1;
          });
        });
      }
    });
    let key = outerValue.id || outerValue.value;
    if (key) {
      let target = result2[key];
      let newResult = [];
      while (target) {
        newResult.push(target.value);
        target = target.p;
      }
      setValue(newResult.reverse() as any);
    } else {
      setValue([] as any);
    }
  }, [opts, outerValue]);

  const handleChange = (value, selectedOptions) => {
    //
    if (selectedOptions?.length > 0) {
      const result = selectedOptions[selectedOptions?.length - 1];
      onChange(result);
      setValue(value || []);
    } else {
      onChange(null);
      setValue(value || []);
    }
  };

  return (
    <SingleCascaderSelect
      style={{ width: "100%" }}
      placeholder={profile?.jobFunctionPlaceholder}
      options={opts}
      value={value}
      onChange={handleChange}
      cascaderStyles={{ maxHeight: 300, overflow: "hidden" }}
      onlySearchInLastedLayer
    />
  );
};

const ArrowIcon = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} fill='none' {...props}>
      <path
        fill='#000'
        fillRule='evenodd'
        d='m7.856 9.311-4.32-4.32a.667.667 0 0 0-.943 0l-.141.142a.667.667 0 0 0 0 .943l5.404 5.404 5.404-5.404a.667.667 0 0 0 0-.943l-.142-.141a.667.667 0 0 0-.942 0l-4.32 4.32Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

const JobFunction = (props: {
  lang: any;
  value: any;
  onChange: (value: any) => void;
  className?: string;
}) => {
  const { lang = {}, value, onChange = () => {}, className = "" } = props;
  const [showModal, setShowModal] = useState(false);
  const profile = lang.profile || {};

  return (
    <div>
      <div
        className={classNames(styles.jobFunction_selector, className)}
        onClick={() => setShowModal(true)}
      >
        <span
          className={
            styles.jobFunction_value + " " + (value?.value ? "" : styles.jobFunction_placeholder)
          }
        >
          {value.value ? value?.value : profile?.jobFunctionPlaceholder}
        </span>
        <span className={styles.jobFunction_arrow}>
          <ArrowIcon />
        </span>
      </div>
      <JobFunctionSingleSelectorFormMobile
        {...props}
        open={showModal}
        onOpenChange={setShowModal}
        text={{
          title: "Job Title",
          expandText: "Expand All",
          collapseText: "Collapse All",
          inputPlaceholder: "Enter a Job Title"
        }}
      />
    </div>
  );
};

export default (props: any) => {
  return isMobile ? <JobFunction {...props} /> : <JobFunctionForPcWithCustom {...props} />;
};
